const TRIPLE_WHALE_SHOP = 'clearly-filtered.myshopify.com';

const decodeShopifyId = (value) => {
  console.log('decoding value', value);
  if (!value || typeof value !== 'string') return '';

  if (value.includes('/')) {
    return value.substring(value.lastIndexOf('/') + 1);
  }

  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    try {
      const decoded = window.atob(value);
      if (decoded.includes('/')) {
        return decoded.substring(decoded.lastIndexOf('/') + 1);
      }
    } catch (error) {
      return value;
    }
  }

  return value;
};

const getTriplePixel = () => {
  if (typeof window === 'undefined') return null;
  if (typeof window.TriplePixel !== 'function') return null;
  return window.TriplePixel;
};

export const trackTripleWhaleAddToCart = ({
  item,
  quantity,
  variant,
  token,
} = {}) => {
  const triplePixel = getTriplePixel();
  if (!triplePixel) return;

  const parsedItem = decodeShopifyId(item);
  const parsedVariant = decodeShopifyId(variant);
  const parsedQuantity = Number(quantity || 0);

  if (!parsedItem || !parsedVariant || !parsedQuantity) return;

  const payload = {
    item: parsedItem,
    q: parsedQuantity,
    v: parsedVariant,
  };

  if (token) {
    payload.token = decodeShopifyId(token);
  }

  triplePixel('AddToCart', payload);
};

export const trackTripleWhaleContact = ({ email, phone } = {}) => {
  const triplePixel = getTriplePixel();
  if (!triplePixel) return;

  const safeEmail = email?.trim();
  const safePhone = phone?.trim();

  if (!safeEmail && !safePhone) return;

  triplePixel('Contact', {
    ...(safeEmail ? { email: safeEmail } : null),
    ...(safePhone ? { phone: safePhone } : null),
  });
};

export const getTripleWhaleShop = () => TRIPLE_WHALE_SHOP;